import { jsx as v } from "react/jsx-runtime";
const o = (l) => /* @__PURE__ */ v(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: /* @__PURE__ */ v(
      "path",
      {
        fill: "currentColor",
        d: "M42 6H22L6 17.29v8.12h4v-4.49h11.91v9.88l-9.97 20.42V58h4v-5.3l32.19-.02V58h4v-6.79L42 30.79v-9.87h12v4.49h4v-8.12L42 6Zm-16.09 4.02H38v8.9H25.91v-8.9Zm0 10.9H38v8.34H25.91v-8.34Zm9.92 12.34-3.85 3.02-3.88-3.02h7.73ZM10.61 18.92l11.29-8v8H10.61Zm14.46 14.51 5.28 4.12-11.82 9.27 6.54-13.39ZM16.83 50.7l15.15-11.88 15.21 11.86-30.36.02Zm28.65-3.89L33.6 37.55l5.25-4.11 6.63 13.37ZM42 18.92V10.9l11.38 8.02H42Z"
      }
    )
  }
);
export {
  o as TheGrid
};
